import axios from '../config/axios';

export const fetchCompanyUsers = async (companyId, currentUser) => {
  if (!companyId || !currentUser) {
    return [];
  }

  if (currentUser.role === 'super_admin') {
    const response = await axios.get(`/api/companies/${companyId}/users`);
    return response.data.data || [];
  }

  const response = await axios.get('/api/users');
  return response.data.data || [];
};

export const formatUserLabel = (user) => {
  const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  return name ? `${name} (${user.email})` : user.email || '';
};

export const filterAssignableUsers = (users, { excludeIds = [], search = '' } = {}) => {
  const excludeSet = new Set(excludeIds.map(String));
  const query = search.trim().toLowerCase();

  return (users || [])
    .filter((user) => user.is_active !== false)
    .filter((user) => !excludeSet.has(String(user.id)))
    .filter((user) => {
      if (!query) {
        return true;
      }
      const name = `${user.first_name || ''} ${user.last_name || ''}`.trim().toLowerCase();
      return name.includes(query) || (user.email || '').toLowerCase().includes(query);
    });
};
